export const stackImg = {
  AWS: "/img/aws.png",
  Docker: "/img/docker.png",
  HTML5: "/img/html5.png",
  CSS3: "/img/css3.png",
  Bootstrap: "/img/bootstrap.png",
  MUI: "/img/mui.png",
  React: "/img/react.png",
  // c: "/img/C.png",
  // cpp: "/img/cpp.png",
  // django: "/img/django.png",
  // flask: "/img/flask.png",
  Github: "/img/github.png",
  NodeJS: "/img/nodejs.png",
  JavaScript: "/img/javascript.png",
  TypeScript: "/img/typescript.png",
  Python: "/img/python.png",
  Express: "/img/express.png",
  MongoDB: "/img/mongodb.png",
  PostgreSQL: "/img/postgresql.png",
  Redis: "/img/redis.png",
  // netlify: "/img/netlify.png",
};
